import React, { useState, useEffect } from "react";
import MyLogo from '../../assets/img/logo_200.png'

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSignInOpen, setIsSignInOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openSignInModal = () => setIsSignInOpen(true);
  const closeSignInModal = () => setIsSignInOpen(false);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-1000 transition-all ${
        isScrolled ? "bg-gray-900 text-white shadow-lg" : "bg-black text-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Brand Logo */}
          <div className="flex-shrink-0">
            <a
              href="/"
              className={`text-xl font-bold ${
                isScrolled ? "text-white" : "text-gray-900"
              }`}
            >   
              <img
                src={MyLogo}
                alt="absoluteenergycorp.com"
                className="object-cover rounded-md relative"
              />
            </a>
          </div>

          {/* Desktop Links */}
          <div className="hidden md:flex space-x-6 ">
            <a
              href="#home"
              className="text-white text-lg hover:text-blue-500 px-3 py-2 rounded-md font-medium"
            >
              HOME
            </a>
            <a
              href="#about"
              className="text-lg hover:text-blue-500 px-3 py-2 rounded-md font-medium"
            >
              WHY US
            </a>
            <a
              href="#services"
              className="text-lg hover:text-blue-500 px-3 py-2 rounded-md font-medium"
            >
              OUR SERVICES
            </a>
            <a
              href="#projects"
              className="text-lg hover:text-blue-500 px-3 py-2 rounded-md font-medium"
            >
              PROJECTS
            </a>
            <a
              href="#testimonials"
              className="text-lg hover:text-blue-500 px-3 py-2 rounded-md font-medium"
            >
              TESTIMONIALS
            </a>
            <a
              href="#contacts"
              className="text-lg hover:text-blue-500 px-3 py-2 rounded-md font-medium"
            >
              CONTACTS
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-500 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMenuOpen && (
          <div
            className="md:hidden bg-white border border-gray-200 rounded-lg shadow-lg mt-2"
          >
            <a
              href="#home"
              className="block text-gray-700 hover:bg-gray-100 px-4 py-2"
            >
              HOME
            </a>
             <a
              href="#about"
              className="block text-gray-700 hover:bg-gray-100 px-4 py-2"
            >
              WHY US
            </a>
            <a
              href="#services"
              className="block text-gray-700 hover:bg-gray-100 px-4 py-2"
            >
              OUR SERVICES
            </a>
            <a
              href="#projects"
              className="block text-gray-700 hover:bg-gray-100 px-4 py-2"
            >
              PROJECTS
            </a>
            <a
              href="#testimonials"
              className="block text-gray-700 hover:bg-gray-100 px-4 py-2"
            >
              TESTIMONIALS
            </a>
            <a
              href="#contacts"
              className="block text-gray-700 hover:bg-gray-100 px-4 py-2"
            >
              CONTACTS
            </a>
          </div>
        )}
      </div>

      {/* Sign In Modal */}
      {isSignInOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={closeSignInModal}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold mb-4">Sign In</h2>
            <form>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-gray-700 font-medium mb-2"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="password"
                  className="block text-gray-700 font-medium mb-2"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600"
              >
                Sign In
              </button>
            </form>
            <div className="mt-4 flex justify-between text-sm text-blue-500">
              <button className="hover:underline">Create Account</button>
              <button className="hover:underline">Forgot Password?</button>
            </div>
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              onClick={closeSignInModal}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
